const handleImageInsert = (quillRef, imagesRef) => {
  const editor = quillRef.current.getEditor();
  const range = editor.getSelection();

  if (!range) {
    editor.focus();
    return;
  }

  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.click();

  input.onchange = () => {
    const file = input.files[0];
    const placeholder = `[[IMAGE_${Date.now()}]]`;

    const reader = new FileReader();
    reader.onload = (e) => {
      const dataUrl = e.target.result;
      editor.insertEmbed(range.index, 'image', dataUrl);
      editor.setSelection(range.index + 1);
      imagesRef.current.push({ file, placeholder });
    };
    reader.readAsDataURL(file);
  };
};

export default handleImageInsert;
